<template>
  <div class="bootscreensignin-div">
    <div class="bootscreensignin-left">
      <div class="left-info">
        <div class="info-classname van-multi-ellipsis--l2">
          {{ courseInfo.arrange.classNames && courseInfo.arrange.classNames.join("，") }}
        </div>
        <div class="info-tempdiv"></div>
        <div class="normalinfo van-ellipsis">
          <span class="iconfont icon-xxkc"></span>
          &nbsp;
          <span class="info-text">{{ courseInfo.arrange.name || "" }}</span>
        </div>
        <div class="normalinfo van-ellipsis">
          <span class="iconfont icon-jiaoshi"></span>
          &nbsp;
          <span class="info-text">{{
            courseInfo.arrange.speakerText || ""
          }}</span>
        </div>
        <div class="normalinfo van-ellipsis">
          <span class="iconfont icon-address"></span>
          &nbsp;
          <span class="info-text">{{ courseInfo.arrange.place || "" }}</span>
        </div>
        <div class="normalinfo van-ellipsis">
          <span class="iconfont icon-rili"></span>
          &nbsp;
          <span class="info-text">{{
            dsf.date.format(courseInfo.arrange.beginDateTime, "mm月dd日 hh:ii")
          }}</span>
        </div>
      </div>
      <div class="left-signin">
        <div
          class="signin-qrcode"
          v-if="courseInfo.attendType.indexOf('3') > -1"
        >
          <img class="signin-qrcode-img" :src="qrCodeImgUrl" alt="" />
        </div>
        <div
          class="signin-face"
          v-else-if="courseInfo.attendType.indexOf('2') > -1"
        >
          <div class="signin-face-title">请刷卡</div>
        </div>
        <div class="signin-video" v-else>
          <div class="signin-video-title">请刷卡</div>
          <img
            class="signin-video-img"
            src="../../../../public/img/product/bootScreen/img-swipe.png"
            alt=""
          />
        </div>
        <div class="signin-info">
          <div class="info-headerbg">
            <van-image
              class="info-headerimg"
              v-if="attendInfo.errorCode && attendInfo.errorCode < 30004"
              :src="attendInfo.photo | imgFormat"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <template v-slot:error>
                <img
                  class="info-headerimg"
                  :src="defaultHeader | imgFormat"
                  style="width: 100%; height: 100%"
                />
              </template>
            </van-image>
            <img class="info-headerimg" v-else :src="defaultHeader" />
          </div>
          <div class="signin-info-content" v-if="attendInfo.errorCode == 30001">
            <div class="success">签到成功</div>
            <div class="name">{{ attendInfo.name }}</div>
          </div>
          <div class="signin-info-content" v-else-if="attendInfo.errorCode == 30002">
            <div class="error">重复签到</div>
            <div class="name">{{ attendInfo.name }}</div>
          </div>
          <div class="signin-info-content" v-else-if="attendInfo.errorCode == 30003">
            <div class="error">重复签退</div>
            <div class="name">{{ attendInfo.name }}</div>
          </div>
          <div class="signin-info-content" v-else-if="attendInfo.errorCode == 30005">
            <div class="error">无效卡</div>
          </div>
          <div class="signin-info-content" v-else>
            <div class="normal-text">请您人脸识别签到或刷卡签到！</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bootscreensignin-temp"></div>
    <div class="bootscreensignin-right">
      <div class="right-signinsituationbutton" @click="getAllStudentSign">签到情况</div>
      <div class="right-signininfo">
        <div class="right-signininfo-normalitem">
          <div class="normalitem-title">实到人数</div>
          <div class="normalitem-text">{{ courseList.realNum || 0 }}</div>
        </div>
        <div class="right-signininfo-normalitem">
          <div class="normalitem-title">应到人数</div>
          <div class="normalitem-text">{{ courseList.shouldNum || 0 }}</div>
        </div>
      </div>
      <div class="right-signinlist">
        <div
          class="signinlist-item"
          v-for="(item, index) in courseList.signMessageList"
          :key="'signinlist-item' + index"
        >
          <van-image
            class="signinlist-item-header"
            :src="item.photo | imgFormat"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
            <template v-slot:error>
              <img
                class="signinlist-item-header"
                :src="defaultImg"
                style="width: 100%; height: 100%"
              />
            </template>
          </van-image>
          <div class="signinlist-item-name van-multi-ellipsis--l2">
            {{ item.name || "" }}
          </div>
          <div class="signinlist-item-time">
            {{ dsf.date.format(item.signInTime, "hh:ii:ss") }}
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      class="bootscreensignin-dialog"
      v-model="showDialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="true"
      get-container="#app"
    >
      <div class="dialog-maindiv">
        <div class="dialog-closebuttondiv">
          <div class="dialog-closenotice">点击任意阴影处关闭</div>
          <div class="dialog-closebutton" @click="showDialog = false">
            <span class="iconfont icon-icon_wrong"></span>
          </div>
        </div>
        <div class="dialog-maininfo">
          <teacher-sign-in-info :stuList="stuList" :classNameSet="courseInfo.arrange && courseInfo.arrange.classNames ? courseInfo.arrange.classNames : []"></teacher-sign-in-info>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      class="bootscreensignin-dialog"
      v-model="showMistakeAddressDialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="true"
      get-container="#app"
    >
      <div class="dialog-maindiv">
        <div class="dialog-closebuttondiv">
          <div class="dialog-closenotice">点击任意阴影处关闭</div>
          <div
            class="dialog-closebutton"
            @click="showMistakeAddressDialog = false"
          >
            <span class="iconfont icon-icon_wrong"></span>
          </div>
        </div>
        <div class="dialog-maininfo">
          <mistake-sign-in-address :attendInfo="attendInfo" :addressInfo="addressInfo" :currentPlace="courseInfo.arrange && courseInfo.arrange.place ? courseInfo.arrange.place : ''"></mistake-sign-in-address>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import teacherSignInInfo from "./teacherSignInInfo.vue";
import mistakeSignInAddress from "./mistakeSignInAddress.vue";
export default {
  data() {
    return {
      showDialog: false,
      showMistakeAddressDialog: false,
      headerImg: "",
      qrCodeImgUrl: "",
      attendInfo: {},
      addressInfo: {},
      courseList: {},
      defaultHeader: require("../../../../public/img/product/bootScreen/headSculpture.png"),
      defaultImg: dsf.config.setting_public_user_default_header,
      stuList: {},
      courseInfo: {
        arrange: {
          classNames: [],
          place: "",
        },
        attendType: "1",
      }, //课程详情
      outTimer: null,
      signInDetailTimer: null,
      refreshQrCodeTimer: null,
      errorAddressTimer: null,
      hiddenSignInHeaderImgTimer: null,
    };
  },
  components: {
    teacherSignInInfo,
    mistakeSignInAddress,
  },
  watch: {
    $route(to, from) {
      if (
        to.path == from.path &&
        from.path == "/mobile/bootScreen/transverse/bootScreenSignIn"
      ) {
        this.getCourseDetail();
        this.getSignCondition();
      }
    },
  },
  mounted() {
    window.swipingCardFunction = this.swipingCardFunction;
    let equipmentId = sessionStorage.getItem("equipmentId") || "";
    this.qrCodeImgUrl =
      "teas/screen/generateQrCode?id=" +
      this.$route.query.id +
      "&relId=" +
      this.$route.query.relId +
      "&attendMode=" +
      this.$route.query.attendMode +
      "&type=" +
      this.$route.query.type +
      "&equipmentId=" +
      equipmentId +
      "&t=" +
      new Date().getTime();
    this.getCourseDetail();
    this.getSignCondition();
  },
  beforeDestroy() {
    if (this.outTimer) {
      clearTimeout(this.outTimer);
    }
    if (this.refreshQrCodeTimer) {
      clearInterval(this.refreshQrCodeTimer);
    }
    if (this.signInDetailTimer) {
      clearInterval(this.signInDetailTimer);
    }
    if (this.errorAddressTimer) {
      clearTimeout(this.errorAddressTimer);
    }
    if (this.hiddenSignInHeaderImgTimer) {
      clearTimeout(this.hiddenSignInHeaderImgTimer);
    }
  },
  methods: {
    //查询课程详情信息
    getCourseDetail() {
      this.attendInfo = {};
      if (this.outTimer) {
        clearTimeout(this.outTimer);
      }
      if (this.refreshQrCodeTimer) {
        clearInterval(this.refreshQrCodeTimer);
      }
      if (this.signInDetailTimer) {
        clearInterval(this.signInDetailTimer);
      }
      if (this.errorAddressTimer) {
        clearTimeout(this.errorAddressTimer);
      }
      if (this.hiddenSignInHeaderImgTimer) {
        clearTimeout(this.hiddenSignInHeaderImgTimer);
      }
      if (this.showDialog) {
        this.showDialog = false;
      }
      if (this.showMistakeAddressDialog) {
        this.showMistakeAddressDialog = false;
      }
      let loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .get(
          "/teas/screen/attendDetails",
          {
            id: this.$route.query.id || "", //事项id
            relId: this.$route.query.relId || "", //事项为课程时的考勤业务id
            courseNoonId: this.$route.query.courseNoonId || "", //事项为课程时的排课午别id
            type: this.$route.query.type || "", //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          dsf.layer.closeLoading(loading);
          if (success) {
            _this.courseInfo = data;
            if (
              data.arrange &&
              data.arrange.attendEndDate &&
              data.arrange.attendEndDate.length > 0
            ) {
              let currentTime = new Date().getTime();
              let endTime = new Date(data.arrange.attendEndDate).getTime();
              let timeIntervalNumber = endTime - currentTime + 3000;
              let tempThis = _this;
              _this.outTimer = setTimeout(() => {
                tempThis.$router.back();
              }, timeIntervalNumber);
            }
            if (data.attendType && data.attendType.indexOf("3") > -1) {
              _this.requestRefreshQrcodeInfo();
              let tempThis = _this;
              _this.signInDetailTimer = setInterval(() => {
                tempThis.getSignCondition();
              }, 2000);
            }
            if (
              _this.$route.query.needSignIn &&
              _this.$route.query.needSignIn == 1
            ) {
              _this.swipingCardFunction(
                _this.$route.query.cardId,
                _this.$route.query.faceInfo
              );
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    requestRefreshQrcodeInfo(){
      let _this = this;
      this.$http
        .get(
          "/teas/attendance/getSystemQrCodeConfig",
          {},
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success && data.codeRefreshValue && data.codeRefreshValue == 1) {
            let tempTime = parseInt(data.refreshSecond);
            if(tempTime > 0){
              let tempThis = _this;
              _this.refreshQrCodeTimer = setInterval(() => {
                tempThis.refreshQrCodeFunction();
              }, tempTime * 1000);
            }
          }
        })
        .error((err) => {

        });
    },
    refreshQrCodeFunction(){
      let equipmentId = sessionStorage.getItem("equipmentId") || "";
      this.qrCodeImgUrl =
        "teas/screen/generateQrCode?id=" +
        this.$route.query.id +
        "&relId=" +
        this.$route.query.relId +
        "&attendMode=" +
        this.$route.query.attendMode +
        "&type=" +
        this.$route.query.type +
        "&equipmentId=" +
        equipmentId +
        "&t=" +
        new Date().getTime();
    },
    //获取所有学员的所有考勤情况
    getAllStudentSign() {
      let _this = this;
      this.$http
        .get(
          "teas/screen/getSignInInfo",
          {
            id: this.$route.query.id || "", //事项id
            type: this.$route.query.type || "", //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            _this.stuList = data;
            _this.showDialog = true;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    //获取课程详情里面的签到情况
    getSignCondition() {
      let _this = this;
      this.$http
        .get(
          "teas/screen/getSignCondition",
          {
            id: this.$route.query.id || "", //事项id
            type: this.$route.query.type || "", //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            _this.courseList = data;
          } else {
            // dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          // dsf.layer.message(err.message || "请求异常", false);
        });
    },
    //刷卡调用方法
    swipingCardFunction(cardId, faceInfo) {
      let _this = this;
      this.$http
        .post(
          "/teas/screen/signIn",
          {
            id: this.$route.query.id || "", //事项id
            relId: this.$route.query.relId || "", //事项为课程时的考勤业务id
            type: this.$route.query.type || "", //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式
            cardId: cardId || "",
            faceInfo: faceInfo || "",
            equipmentId: sessionStorage.getItem("equipmentId") || "",
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            if (!dsf.isEmptyObject(_this.attendInfo)) {
              _this.attendInfo = {};
            }
            if (_this.showDialog) {
              _this.showDialog = false;
            }
            if (_this.showMistakeAddressDialog) {
              _this.showMistakeAddressDialog = false;
            }
            let code =
              data.signMessage && data.signMessage.errorCode
                ? data.signMessage.errorCode
                : 0;
            switch (code) {
              case 30001: {
                _this.attendInfo = data.signMessage || {};
                _this.getSignCondition();
                _this.setHiddenHeaderImgTimer();
                break;
              }
              case 30002: {
                _this.attendInfo = data.signMessage || {};
                _this.setHiddenHeaderImgTimer();
                break;
              }
              case 30003: {
                _this.attendInfo = data.signMessage || {};
                _this.setHiddenHeaderImgTimer();
                break;
              }
              case 30004: {
                if (_this.errorAddressTimer) {
                  clearTimeout(_this.errorAddressTimer);
                }
                _this.addressInfo = data.jumpArrange || {};
                _this.attendInfo = data.signMessage || {};
                _this.showMistakeAddressDialog = true;
                let tempThis = _this;
                _this.errorAddressTimer = setTimeout(() => {
                  tempThis.attendInfo = {};
                  tempThis.showMistakeAddressDialog = false;
                }, 10000);
                break;
              }
              case 30005: {
                _this.attendInfo = data.signMessage || {};
                _this.setHiddenHeaderImgTimer();
                break;
              }
              case 30006: {
                //跳转课程
                let tempObject = data.currentArrange || {};
                var url =
                  "/mobile/bootScreen/transverse/bootScreenSignIn?id=" +
                  tempObject["id"] +
                  "&relId=" +
                  tempObject["relId"] +
                  "&courseNoonId=" +
                  tempObject["courseNoonId"] +
                  "&type=" +
                  tempObject["typeValue"] +
                  "&attendMode=" +
                  tempObject["courseAttendMode"] +
                  "&cardId=" +
                  cardId +
                  "&faceInfo=" +
                  faceInfo +
                  "&needSignIn=1";
                _this.$router.replace({
                  path: url,
                });
                break;
              }
              default:
                break;
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    setHiddenHeaderImgTimer() {
      if (this.hiddenSignInHeaderImgTimer) {
        clearTimeout(this.hiddenSignInHeaderImgTimer);
      }
      let timeCount =
        parseInt(dsf.config.setting_screen_photo_show_time) * 1000;
      let _this = this;
      this.hiddenSignInHeaderImgTimer = setTimeout(() => {
        _this.attendInfo = {};
      }, timeCount);
    },
  },
};
</script>

<style>
</style>
